import styled from "styled-components";

export const SkeletonContainer = styled.div`
  padding: 20px 20px 100px 20px;
`;
